export type CategoryCounts = {
  blower: number;
  dehumidifier: number;
  airScrubber: number;
  other: number;
};

type CategorizedItem = { product_category?: string };

// Product-group counts for remediation equipment, bucketed by product_category
// the same way the Assign Equipment dialog's "By Category" KPI does. Shared by
// the field-service screens and the job-site Assigned Equipment tab.
export const countByCategory = (items?: CategorizedItem[]): CategoryCounts => {
  const result: CategoryCounts = { blower: 0, dehumidifier: 0, airScrubber: 0, other: 0 };
  (items ?? []).forEach((row) => {
    const key = (row.product_category ?? 'Other').toLowerCase();
    if (key === 'blower') result.blower += 1;
    else if (key === 'dehumidifier') result.dehumidifier += 1;
    else if (key === 'air scrubber') result.airScrubber += 1;
    else result.other += 1;
  });
  return result;
};

// KPI rows for the shared "By Category" widget shape. fullLabels spells the
// categories out (wider desktop layouts); the default keeps the compact
// abbreviations used on mobile/field-service screens.
export const categoryKpiData = (items?: CategorizedItem[], fullLabels = false): { amount: number; label: string; color: string }[] => {
  const counts = countByCategory(items);
  return [
    { amount: counts.blower, label: 'Blower', color: 'black' },
    { amount: counts.dehumidifier, label: fullLabels ? 'Dehumidifier' : 'Dehum', color: 'black' },
    { amount: counts.airScrubber, label: fullLabels ? 'Air Scrubber' : 'Air Scr', color: 'black' },
    { amount: counts.other, label: 'Other', color: 'black' },
  ];
};

// Compact one-line summary, e.g. "3 Blower · 2 Dehum · 1 Other" (zeros omitted).
export const categorySummary = (items?: CategorizedItem[]): string => {
  const counts = countByCategory(items);
  return (
    [
      [counts.blower, 'Blower'],
      [counts.dehumidifier, 'Dehum'],
      [counts.airScrubber, 'Air Scr'],
      [counts.other, 'Other'],
    ] as [number, string][]
  )
    .filter(([amount]) => amount > 0)
    .map(([amount, label]) => `${amount} ${label}`)
    .join(' · ');
};
